import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import {
  Button,
  Typography,
  Header,
  Spacing,
  MyTextInput,
} from 'components/src';
import { Platform, createUseStyles, routesName, useLang } from 'core/src';
import Octicons from 'react-native-vector-icons/Octicons';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { useTranslation } from 'react-i18next';
import { SocketIOContext } from '../../app/appcontainer';

const MaterialIconsX = MaterialIcons as unknown as React.ComponentType<any>;
const OcticonsX = Octicons as unknown as React.ComponentType<any>;

interface DrawerMenuProps {
  navigation: any;
  setSearchText?: any;
  setOpen: any;
}

const MainHeader: React.FC<DrawerMenuProps> = memo(
  ({ navigation, setSearchText, setOpen }) => {
    const { styles, colors } = useStyles();
    const { lang } = useLang();
    const [search, setSearch] = useState<boolean>(false);
    const { i18n } = useTranslation();
    const [connected, setConnected] = useState<boolean>(false);
    const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
      if (SocketIOContext.connection?.connected) {
        setConnected(true);
      } else setConnected(false);
    }, [SocketIOContext.connection?.connected]);

    useEffect(() => {
      !search && setSearchText('');
    }, [search]);

    const handleSearchChange = useCallback(
      (text: any) => {
        if (typingTimeoutRef.current) {
          clearTimeout(typingTimeoutRef.current);
        }
        typingTimeoutRef.current = setTimeout(() => {
          setSearchText(text);
        }, 1500);
      },
      [setSearchText],
    );

    const openProfile = () => {
      Platform.isDesktop
        ? setOpen('profile')
        : navigation.navigate(routesName.PROFILE);
    };

    SocketIOContext.useSocketEffect<any, any>(
      'connectionSuccess',
      (event: any): any => {
        setConnected(true);
      },
      [],
    );

    return (
      <>
        <Header
          classes={{
            flexDirection: lang === 'fa-IR' ? 'row-reverse' : 'row',
          }}
        >
          {search ? (
            <>
              <Button
                onClick={() => {
                  setSearch(false);
                }}
              >
                <MaterialIconsX
                  name={lang === 'fa-IR' ? 'arrow-forward' : 'arrow-back'}
                  size={25}
                  color={colors.white}
                />
              </Button>
              <Spacing horizontal={7} />
              <MyTextInput
                change={handleSearchChange}
                classes={styles.input}
                placeholder={i18n.t('search')}
                focus={search ? true : false}
              />
            </>
          ) : (
            <>
              <Button onClick={openProfile}>
                <OcticonsX name="three-bars" color={colors.white} size={20} />
              </Button>
              <Typography
                color={colors.white}
                text={connected ? i18n.t('messenger') : 'Connecting...'}
                weight="bold"
              />
            </>
          )}
          <Button
            onClick={() => {
              setSearch(true);
            }}
          >
            <MaterialIconsX name="search" size={25} color={colors.white} />
          </Button>
        </Header>
      </>
    );
  },
);

const useStyles = createUseStyles(({ colors, theme }) => ({
  input: {
    flex: 1,
    backgroundColor: 'transparent',
    elevation: 0,
    textAlign: 'left',
  },
}));

export { MainHeader };
